import React from 'react';

const Services = () => {
    const servicesData = [
        {
            icon: "local_shipping",
            title: "Wholesale Supply",
            description: "Bulk supply for contractors and large projects with competitive pricing"
        },
        {
            icon: "storefront",
            title: "Retail Sales",
            description: "Individual product sales with expert advice for your home renovation needs"
        },
        {
            icon: "design_services",
            title: "Custom Solutions",
            description: "Tailored products and designs to meet specific project requirements"
        }
    ];

    return (
        <section className="services">
            <div className="container">
                <div className="section-title">
                    <h2>Our Services</h2>
                    <p>Comprehensive solutions for all your construction and renovation needs</p>
                </div>
                <div className="service-cards">
                    {servicesData.map((service, index) => (
                        <div key={index} className="service-card">
                            <span className="material-icons service-icon">{service.icon}</span>
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;